import Vue from 'vue'

Vue.filter('orderStatusColor', value => {
  const colors = {
    placed: 'light-blue darken-3',
    approved: 'light-blue',
    processing: 'green',
    on_hold: 'orange darken-1',
    refunded: 'deep-orange darken-1',
    shipped: 'indigo darken-3',
    canceled: 'grey darken-3',
    completed: 'light-green',
    guest: 'grey'
  }

  return colors[value] || 'grey'
})
